import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import DashboardLaneActionableItemModel from "../../models/dashboard-lane-actionable-item";

export default class DashboardLanesActionableItemsRepository extends BaseRepository {
  static modelClass = DashboardLaneActionableItemModel;
  modelName = "dashboard-lane-actionable-item";

  async query(id, params) {
    const urlString = "dashboard_lanes/" + id + "/action_items";
    const queryString = params ? "?" + qs.stringify(params) : "";

    return await super.query({
      urlPath: urlString + queryString,
    });
  }
}
